import { OpenTimeType, BusinessTimeType, HandleBusinessTimeType } from 'types/store'
import { DaysOfWeek, DayOfWeekType } from 'lib/daysOfWeek'
import { parseTimeToNumber } from './helper'
import { StoreCalendarType } from 'types/storeCalendar'
const daysOfWeek = new DaysOfWeek()

export const getOpenTimeOnDay = (
  dayOfWeek: DayOfWeekType,
  businessHours: OpenTimeType | undefined,
  date?: string,
  storeCalendars?: StoreCalendarType[]
): string | null => {
  // businessHoursを取得前or未設定の場合は判定しない
  if (!businessHours || Object.keys(businessHours).length === 0) return null
  const hour = businessHours[dayOfWeek]
  // 臨時営業日かどうか判定
  if (date && storeCalendars) {
    const storeCalendar = storeCalendars.find((calendar) => calendar.date === date && calendar.status === 'open')
    // 臨時営業日ではない
    if (!storeCalendar || !storeCalendar.open_time) {
      if (!hour || !hour.open_time) return null
      return hour.open_time
    }
    // 臨時営業日
    return storeCalendar.open_time
  } else {
    if (!hour || !hour.open_time) return null
    return hour.open_time
  }
}

export const getLatestOpenTime = (daysOfWeek: DayOfWeekType[], openTime: OpenTimeType): string => {
  return daysOfWeek.reduce((prev, dayOfWeek) => {
    const time = openTime[dayOfWeek]
    if (!time) return prev
    if (parseTimeToNumber(time.open_time) <= parseTimeToNumber(prev)) return prev
    return time.open_time
  }, '00:00')
}

export const getLatestOrderStartTime = (daysOfWeek: DayOfWeekType[], orderStartTime: BusinessTimeType): string => {
  return daysOfWeek.reduce((prev, dayOfWeek) => {
    const time = orderStartTime[dayOfWeek]
    if (!time) return prev
    if (parseTimeToNumber(time) <= parseTimeToNumber(prev)) return prev
    return time
  }, '00:00')
}

export const getEarliestOrderStartTime = (daysOfWeek: DayOfWeekType[], orderStartTime: BusinessTimeType): string => {
  return daysOfWeek.reduce((prev, dayOfWeek) => {
    const time = orderStartTime[dayOfWeek]
    if (!time) return prev
    if (parseTimeToNumber(time) >= parseTimeToNumber(prev)) return prev
    return time
  }, '23:45')
}

export const getEarliestLastTime = (daysOfWeek: DayOfWeekType[], lastTime: BusinessTimeType): string => {
  return daysOfWeek.reduce((prev, dayOfWeek) => {
    const time = lastTime[dayOfWeek]
    if (!time) return prev
    if (parseTimeToNumber(time) >= parseTimeToNumber(prev)) return prev
    return time
  }, '23:45')
}

export const getBusinessTimeOnDay = (
  dayOfWeek: DayOfWeekType,
  times: BusinessTimeType | undefined,
  date?: string,
  storeCalendars?: StoreCalendarType[],
  type?: 'order_start_time' | 'last_order_time' | 'last_pickup_time' // | 'relative_pickupable_time'
): string | null => {
  // timesを取得前or未設定の場合は判定しない
  if (!times || Object.keys(times).length === 0) return null
  // 臨時営業日かどうか判定
  if (date && storeCalendars && type) {
    const storeCalendar = storeCalendars.find((calendar) => calendar.date === date && calendar.status === 'open')
    // 通常営業日の場合
    if (!storeCalendar) {
      return times[dayOfWeek]
    }
    // 臨時営業日の場合
    switch (type) {
      case 'order_start_time':
        if (!storeCalendar.order_start_time) return null
        return storeCalendar.order_start_time
      case 'last_order_time':
        if (!storeCalendar.last_order_time) return null
        return storeCalendar.last_order_time
      case 'last_pickup_time':
        if (!storeCalendar.last_pickup_time) return null
        return storeCalendar.last_pickup_time
      // case 'relative_pickupable_time':
      //   if (!storeCalendar.relative_pickupable_time) return null
      //   return storeCalendar.relative_pickupable_time
      default:
        return null
    }
  } else {
    return times[dayOfWeek]
  }
}

export const parseToOpenTime = (businessTimes: HandleBusinessTimeType[]): OpenTimeType => {
  const daysOfWeekValue = daysOfWeek.getDaysOfWeek()
  const times: OpenTimeType = {}
  for (let i = 0; i < daysOfWeekValue.length; i = (i + 1) | 0) {
    const dayOfWeek = daysOfWeekValue[i]
    const businessTime = businessTimes.find((businessTime) => businessTime.days_of_week.includes(dayOfWeek))
    if (!businessTime) continue
    times[dayOfWeek] = { open_time: businessTime.open_time }
  }
  return times
}

export const parseToBusinessTime = (
  businessTimes: HandleBusinessTimeType[],
  type: 'order_start_time' | 'last_order_time' | 'last_pickup_time' | 'relative_pickupable_time'
): BusinessTimeType => {
  const daysOfWeekValue = daysOfWeek.getDaysOfWeek()
  const times: BusinessTimeType = {}
  for (let i = 0; i < daysOfWeekValue.length; i = (i + 1) | 0) {
    const dayOfWeek = daysOfWeekValue[i]
    const businessTime = businessTimes.find((businessTime) => businessTime.days_of_week.includes(dayOfWeek))
    if (!businessTime) {
      times[dayOfWeek] = null
    } else {
      switch (type) {
        case 'order_start_time':
          times[dayOfWeek] = businessTime.order_start_time
          break
        case 'last_order_time':
          times[dayOfWeek] = businessTime.last_order_time
          break
        case 'last_pickup_time':
          times[dayOfWeek] = businessTime.last_pickup_time
          break
        case 'relative_pickupable_time':
          times[dayOfWeek] = businessTime.relative_pickupable_time
          break
        default:
          break
      }
    }
  }
  return times
}
